module.exports = __webpack_public_path__ + "static/media/undervisningsministeriet.837078d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/undervisningsministeriet.jpg
// module id = 1475
// module chunks = 0